import { useQuery } from "react-query";
import { getUserDetails } from "services/user.service";

export default function useUserDetails(id) {
  return useQuery(["users", id], async () => await getUserDetails(id), {
    enabled: id ? true : false,
  });
}
